module.exports = __webpack_public_path__ + "static/goodjuju_v2-917864d72880b4c8f7a185c6a073686a.jpg";